import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import HowItWorks from "@/components/HowItWorks";
import Difference from "@/components/Difference";
import SocialProof from "@/components/SocialProof";
import Features from "@/components/Features";
import Pricing from "@/components/Pricing";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-white selection:bg-accent/20 selection:text-primary">
      <Navbar />
      <Hero />
      <Problem />
      <Solution />
      <HowItWorks />
      <Difference />
      <SocialProof />
      <Features />
      <Pricing />
      <FinalCTA />
      <Footer />
    </main>
  );
}
